<div class="ui-g m-b-0">
  <div class="ui-g-offset-3 ui-g-9">
    <h3 class="text-left m-t-0">{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.TITLE' | translate }}</h3>
  </div>
</div>

<div *ngFor="let contact of contacts" class="ui-g m-b-0">
  <div class="ui-g-3 text-right" style="position: relative;">
    <label>
      {{ 'CONTACT_TYPES.' + contact.type | translate }}
    </label>
    <i *ngIf="contact.preferred" class="fa fa-check preferred-contact"></i>
  </div>
  <div class="ui-g-9 m-t-10">
    <p>
      {{contact.value}}
      <i class="fa fa-pen edit-contact"
         (click)="modify(contact)"
         pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.MODIFY_CONTACT_TOOLTIP' | translate }}"
         tooltipPosition="bottom">
      </i>
      <i class="fa fa-trash delete-contact"
         (click)="delete(contact)"
         pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.REMOVE_CONTACT_TOOLTIP' | translate }}"
         tooltipPosition="bottom">
      </i></p>


  </div>
</div>

<div *ngFor="let address of addresses">
  <div class="ui-g">
    <div class="ui-g-3 text-right">
      <label>{{ 'LOCATION_TYPES.' + address.locationType | translate}}</label>
    </div>
    <div class="ui-g-9 m-b-0 m-t-10">
      <div>
        <p *ngIf="address.address1">{{ address.address1 }}</p>
        <p *ngIf="address.address2">{{ address.address2 }}</p>
        <p *ngIf="address.address3">{{ address.address3 }}</p>
        <p *ngIf="address.address4">{{ address.address4 }}</p>
        <p *ngIf="address.townCity || address.zip">
          <span>{{ address.townCity }}</span>
          <span>{{ address.zip }}</span>
        </p>
        <p *ngIf="address.country?.name">{{ address.country?.name }}</p>
        <i class="fa fa-pen edit-contact"
           (click)="modifyAddress(address)"
           pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.MODIFY_CONTACT_TOOLTIP' | translate }}"
           tooltipPosition="bottom">
        </i>
        <i class="fa fa-trash delete-contact"
           (click)="deleteAddress(address)"
           pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.REMOVE_CONTACT_TOOLTIP' | translate }}"
           tooltipPosition="bottom">
        </i>
      </div>
    </div>
  </div>
</div>

<div class="ui-g">
  <div class="ui-g-offset-3 ui-g-9">
    <button pButton
            type="button"
            label="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.ADD_CONTACT_BTN' | translate }}"
            (click)="addContact()">
    </button>
  </div>
</div>

<wsd-add-contact
  [countryId]="countryId"
  [includingPostAddress]="includingPostAddress"
  [contacts]="contacts"
  [isOrganization]="isOrganization"
  (onSave)="onSave($event)">
</wsd-add-contact>
